let state = {
  currentStep: 0,
  numberOfSteps: 0,
  signupStatus: undefined,
  userEmail: undefined,
  waitTime: undefined,
  waitMessage: undefined,
  presetEmail: undefined,
  dmiEligible: undefined,
  signupMobile: undefined
};
export default state;



// WEBPACK FOOTER //
// ./src/store/signup/state.js